import {
	listResourceQueryDefinitions,
	viewResourceQueryDefinitions,
	createResourceMutationDefinitions,
	updateResourceMutationDefinitions
} from '@/providers/graphql/resourceQueryDefinitions';
import gql from 'graphql-tag';

export const LIMITS_LIST_QUERY = gql`
	query Limits($first: Int, $after: String) {
		limits(first: $first, after: $after) {
			nodes {
				limitId
				name
				minAmount
				maxAmount
				minStayMinutes
				maxStayMinutes
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;

export const LIMIT_QUERY = gql`
	query Limit($id: Ulid!) {
		limit(limitId: $id) {
			limitId
			name
			minAmount
			maxAmount
			minStayMinutes
			maxStayMinutes
		}
	}
`;

// Separate query for references tab - lazy loaded
export const LIMIT_REFERENCES_QUERY = gql`
	query LimitReferences($id: Ulid!) {
		limit(limitId: $id) {
			limitId
			pricingPolicies {
				pricingPolicyId
				name
				isActive
			}
		}
	}
`;

export const LIMIT_LIST_ITEM_QUERY = gql`
	query LimitListItem($id: Ulid!) {
		limit(limitId: $id) {
			limitId
			name
			minAmount
			maxAmount
			minStayMinutes
			maxStayMinutes
		}
	}
`;

export const LIMIT_CREATE_MUTATION = gql`
	mutation CreateLimit($input: CreateLimitInput!) {
		createLimit(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

export const LIMIT_UPDATE_MUTATION = gql`
	mutation UpdateLimit($input: UpdateLimitInput!) {
		updateLimit(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

export const LIMIT_DELETE_MUTATION = gql`
	mutation DeleteLimit($input: DeleteLimitInput!) {
		deleteLimit(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

listResourceQueryDefinitions['limits'] = {
	document: LIMITS_LIST_QUERY,
	dataPath: 'limits'
};

viewResourceQueryDefinitions['limits'] = {
	document: LIMIT_QUERY,
	dataPath: 'limit'
};

createResourceMutationDefinitions['limits'] = {
	document: LIMIT_CREATE_MUTATION,
	operation: 'createLimit',
	getVariables: variables => ({ input: variables })
};

updateResourceMutationDefinitions['limits'] = {
	document: LIMIT_UPDATE_MUTATION,
	operation: 'updateLimit',
	getVariables: variables => ({ input: variables })
};
